import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caregiver-management-dashboard-title',
  templateUrl: './caregiver-management-dashboard-title.component.html',
  styleUrls: ['./caregiver-management-dashboard-title.component.scss'],
  standalone: true,
  imports: [],
})
export class CaregiverManagementDashboardTitleComponent {
}
